import { ReactNode } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { WorksheetField } from '~/features/projectWizard/worksheets/common/components/Field';
import WorksheetForm from '~/features/projectWizard/worksheets/common/components/WorksheetForm';
import { DeploymentTypeDropdownOptions } from '~/constants/deployment-type';
import { DevelopmentStageDropdownOptions } from '~/constants/development-stage';
import { PricingTypeDropdownOptions, PricingTypeDisplay, PricingTypeDescriptions } from '~/constants';
import { useDerivedRECFields, useDerivedProjectSetupFields } from '~/features/projectWizard/derived';
import { useDerivedContractFields } from '~/features/projectWizard/worksheets/common/derived/useDerivedContractFields';

const toDropdownOptions = <T extends { value: unknown; label: ReactNode }>(options: T[]) =>
  options.map(({ label, ...rest }) => ({ ...rest, text: label }));

const pricingTypeInfoContent = (
  <div>
    {PricingTypeDropdownOptions.map(({ value }) => (
      <p key={value as string} style={{ marginBottom: '0.5em' }}>
        <strong>{PricingTypeDisplay[value as string]}</strong>
        {' – '}
        {PricingTypeDescriptions[value as string]}
      </p>
    ))}
  </div>
);

const pricingTypeLabel = (
  <>
    What type of bids are you seeking?{' '}
    <Popup
      trigger={
        <Icon
          name="info circle"
          style={{ marginLeft: '4px', cursor: 'pointer', color: 'var(--color-secondary)' }}
        />
      }
      content={pricingTypeInfoContent}
      wide
      hoverable
      on={['hover', 'click']}
    />
  </>
);

export default function ProjectFoundations () {
  // Update certain values automatically based on field changes
  useDerivedProjectSetupFields();
  useDerivedRECFields();
  useDerivedContractFields();

  return (
    <WorksheetForm>
      <WorksheetField
        type="dropdown"
        schemaKey="deploymentType"
        fieldLabel="What type of project is this?"
        placeholder="Select a project type"
        options={DeploymentTypeDropdownOptions}
      />
      <WorksheetField
        type="dropdown"
        schemaKey="developmentStage"
        fieldLabel="At which stage would you like to transact?"
        placeholder="Select a stage"
        options={DevelopmentStageDropdownOptions}
      />
      <WorksheetField
        type="dropdown"
        schemaKey="pricingType"
        fieldLabel={pricingTypeLabel}
        placeholder="Select a bid type"
        options={toDropdownOptions(PricingTypeDropdownOptions)}
      />
    </WorksheetForm>
  );
}